import * as Sentry from '@sentry/browser';
// eslint-disable-next-line import/no-cycle
import { QUESTION_IDS } from 'new-ui/Components/Intake';
import configs from 'configs';
import { authHeaders } from 'functions/authHeader';
import handleResponse from 'functions/handleResponse';

const apiUrl = configs.beApiUrl;

function getQuestionnaireRoutePath(questionId, searchParams) {
  const params = new URLSearchParams(searchParams);

  return `/questionnaire/${questionId}${params.toString() ? `?${params.toString()}` : ''}`;
}

const getQuestionRoutePath = (questionId, condition, additionalParams) => {
  if (questionId === QUESTION_IDS.BIOMARKERS) {
    return `question/${questionId}${condition ? `/${condition}` : ''}`;
  }

  if (questionId === 'drugs_received') {
    let path = `question/${questionId}`;
    if (condition) {
      path += `/${condition}`;
      if (additionalParams) {
        path += `?${new URLSearchParams(additionalParams).toString()}`;
      }
    }
    return path;
  }

  return `question/${questionId}`;
};

const getQuestionOptions = async (questionId, condition, additionalParams) => {
  const requestOptions = {
    method: 'GET',
    headers: await authHeaders(),
  };

  return fetch(apiUrl + getQuestionnaireRoutePath(
    getQuestionRoutePath(questionId, condition, additionalParams),
  ), requestOptions)
    .then(handleResponse)
    .catch((ex) => {
      Sentry.captureException(ex);
      console.error('Error occurred, while getting profile data:', ex);
    });
};

const getBiomarkers = async (condition) => {
  const { data, success } = await getQuestionOptions('biomarkers', condition);
  if (!success) {
    throw new Error('getBiomarkers response.success: false');
  }
  return data;
};

const getDrugs = async (condition, additionalParams) => {
  const { data, success } = await getQuestionOptions('drugs_received', condition, additionalParams);
  if (!success) {
    throw new Error('getDrugs response.success: false');
  }
  return data;
};

const getDiseasesList = async () => {
  const response = await fetch(apiUrl + getQuestionnaireRoutePath('diseases'));
  const { data } = await response.json();

  return data;
};

const getQuestionnaireStructure = async (diseaseId, additionalParams) => {
  const route = getQuestionnaireRoutePath(diseaseId, additionalParams);
  const response = await fetch(apiUrl + route);
  const { data } = await response.json();

  return data;
};

export const questionnaireApi = {
  getQuestionOptions,
  getDiseasesList,
  getQuestionnaireStructure,
  getBiomarkers,
  getDrugs,
};
